import { render, staticRenderFns } from "./TarifaLavado.vue?vue&type=template&id=3dcdfd1e&"
import script from "./TarifaLavado.vue?vue&type=script&lang=js&"
export * from "./TarifaLavado.vue?vue&type=script&lang=js&"
import style0 from "./TarifaLavado.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports